import { Component, OnInit, ChangeDetectionStrategy, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-retroalimentacion-dialogo-comentario',
  standalone: false,
  templateUrl: './retroalimentacion-dialogo-comentario.component.html',
  styleUrls: ['./retroalimentacion-dialogo-comentario.component.scss','../retroalimentacion.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RetroalimentacionDialogoComentarioComponent implements OnInit {

  comentarios;

  commentTargetID;

  fechas$;

  evento$: Observable<any>;

  alumno: any;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    this.comentarios = data.comentarios;
    this.commentTargetID = data.targetId;
    this.fechas$ = data.fechas$;
    this.evento$ = data.evento$;
    this.alumno = data.alumno;
  }

  ngOnInit(): void { }

}
